import React from 'react';
import { Tooltip } from '@material-ui/core';
import { Pill } from '@/components/ExpandableGrid/blocks';
import { getForwardStockingTag } from '@/utilities/forwardStocking';

const ForwardStockingTag = ({ order, short = false, className }) => {
    const tag = getForwardStockingTag(order);
    if (!tag) return null;

    return (
        <Tooltip title={tag.tooltip} placement="top" arrow>
            <Pill color={tag.color} minWidth="0" className={className}>
                {short ? tag.shortLabel : tag.label}
            </Pill>
        </Tooltip>
    );
};

export default ForwardStockingTag;
